import { ProductCategory } from "../appliance";
import { Money } from "../common/money";
import { SolarProductImage } from "./solar-product-image";
import { SolarProductType } from "./solar-product-type";

export class SolarProduct {
	id?: string;
	isDeactivated: boolean;
	isArchived: boolean;
	productName: string;
	productCapacity: number;
	price: Money;
	activeDuration?: number;
	packageDescription?: string;
	batteryType?: string;

	inverterType: string;
	warranty: string;
	batteryVoltage?: string;
	type: SolarProductType;
	quantityAvailableForSale?: number;
	numberOfOrders?: number;

	installationCostForBungalow: Money;
	installationCostForFloorForStoryBuilding: Money;
	hotDeal: boolean;
	images: SolarProductImage[];
	floors: number;
	categories: ProductCategory[];
	isWishlisted : Boolean | null ;
	name?: string;
	brand? : string;
	available?: boolean;
	lowestPrice? : Money;
	maximumNumberOfMonths? : number;
	capacity? : number;
	constructor({
		id,
		isDeactivated,
		isArchived,
		productName,
		productCapacity,
		price,
		activeDuration,
		packageDescription,
		batteryType,
		inverterType,
		warranty,
		batteryVoltage,
		type,
		quantityAvailableForSale,
		numberOfOrders,
		installationCostForBungalow,
		installationCostForFloorForStoryBuilding,
		hotDeal,
		images,
		floors,
		categories,
		isWishlisted,
		name,
		brand,
		available,
		lowestPrice,
		maximumNumberOfMonths,
		capacity,
	}: SolarProduct) {
		this.id = id;
		this.isDeactivated = isDeactivated;
		this.isArchived = isArchived;
		this.productName = productName;
		this.productCapacity = productCapacity;
		this.price = price;
		this.activeDuration = activeDuration;
		this.packageDescription = packageDescription;
		this.batteryType = batteryType;
		this.inverterType = inverterType;
		this.warranty = warranty;
		this.batteryVoltage = batteryVoltage;
		this.type = type;
		this.quantityAvailableForSale = quantityAvailableForSale;
		this.numberOfOrders = numberOfOrders;
		this.installationCostForBungalow = installationCostForBungalow;
		this.installationCostForFloorForStoryBuilding = installationCostForFloorForStoryBuilding;
		this.hotDeal = hotDeal;
		this.images = images;
		this.floors = floors;
		this.categories = categories;
		this.isWishlisted = isWishlisted;
		this.name = name;
		this.brand =  brand;
		this.lowestPrice = lowestPrice;
		this.maximumNumberOfMonths = maximumNumberOfMonths;
		this.available = available;
		this.capacity = capacity;
	}
}
